<template>
  <div class="navbar-small h-100"> 
    <div
      class="offcanvas offcanvas-start"
      tabindex="-1"
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel"
    >
      <div class="offcanvas-header bg-info text-white">
        <h2 class="offcanvas-title mt-3 ms-3" id="offcanvasNavbarLabel">Bitácora Digital</h2>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body bg-info">
        <div class="ms-5">
          <a class="btn text-start w-100 mt-4 texto" @click="seleccion('a')">
            <img src="../../../../public/icons/home02.svg" class="me-2" v-show="seleccionadoA"/>
            <img src="../../../../public/icons/home01.svg" class="me-2" v-show="!seleccionadoA"/>
            <span class="col-md-10" :class="`${subrayadoA}`">Dashboard</span>
          </a>
          <a class="btn text-start w-100 mt-4 texto" @click="seleccion('c')">
            <img src="../../../../public/icons/comite02.svg" class="me-2" v-show="seleccionadoC"/>
            <img src="../../../../public/icons/comite01.svg" class="me-2" v-show="!seleccionadoC"/>
            <span class="col-md-10" :class="`${subrayadoC}`">En resolución</span>
          </a>
          <a class="btn text-start w-100 mt-4  texto" @click="seleccion('b')">
            <img src="../../../../public/icons/process02.svg" class="me-2" v-show="seleccionadoB"/>
            <img src="../../../../public/icons/process01.svg" class="me-2" v-show="!seleccionadoB"/>
            <span class="col-md-10" :class="`${subrayadoB}`">En proceso</span>
          </a>
          <a class="btn text-start w-100 mt-4 texto" @click="seleccion('d')">
            <img src="../../../../public/icons/clock02.svg" class="me-2" v-show="seleccionadoD"/>
            <img src="../../../../public/icons/clock01.svg" class="me-2" v-show="!seleccionadoD"/>
            <span class="col-md-10" :class="`${subrayadoD}`">Dictaminadas</span>
          </a>
          <a class="btn text-start w-100 mt-4 texto" @click="seleccion('e')">
            <img src="../../../../public/icons/guia02.svg" class="me-2 iconoGuia" v-show="seleccionadoE"/>
            <img src="../../../../public/icons/guia01.svg" class="me-2 iconoGuia" v-show="!seleccionadoE"/>
            <span class="col-md-10" :class="`${subrayadoE}`">Guía de Referencia</span>
          </a>
          <!--
          <a class="btn text-start w-100 mt-4 texto" @click="seleccion('f')">
            <div>
              <span class="col-md-10" :class="`${this.subrayadoE}`">Agregar Usuario</span>
            </div>
          </a>
          -->
        </div>
      </div>
    </div>
  </div>

  <nav id="navegacionLateral" class="col-sm-0 col-md-2 nav flex-column bg-info h-100 text-white position-fixed navbar-normal">
    <div class="">
      <h2>Bitácora Digital</h2>
    </div>
    <div class="menuLateral">
      <a class="btn text-start w-100 mt-4 texto" @click="seleccion('a')">
        <img src="../../../../public/icons/home02.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="seleccionadoA"/>
        <img src="../../../../public/icons/home01.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="!seleccionadoA"/>
        <span class="col-md-10 textoNavegacion" :class="`${subrayadoA}`">Dashboard</span>
      </a>
      <a class="btn text-start w-100 mt-4  texto" @click="seleccion('c')">
        <img src="../../../../public/icons/comite02.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="seleccionadoC"/>
        <img src="../../../../public/icons/comite01.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="!seleccionadoC"/>
        <span class="col-md-10 textoNavegacion" :class="`${subrayadoC}`">En resolución</span>
      </a>
      <a class="btn text-start w-100 mt-4  texto" @click="seleccion('b')">
        <img src="../../../../public/icons/process02.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="seleccionadoB"/>
        <img src="../../../../public/icons/process01.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="!seleccionadoB"/>
        <span class="col-md-10 textoNavegacion" :class="`${subrayadoB}`">En proceso</span>
      </a>
      <a class="btn text-start w-100 mt-4 texto" @click="seleccion('d')">
        <img src="../../../../public/icons/clock02.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="seleccionadoD"/>
        <img src="../../../../public/icons/clock01.svg" class="col-sm-12 col-md-2 me-2 iconoMenu" v-show="!seleccionadoD"/>
        <span class="col-md-10 textoNavegacion" :class="`${subrayadoD}`">Dictaminadas</span>
      </a>
      <a class="btn text-start w-100 mt-4 texto" @click="seleccion('e')">
        <img src="../../../../public/icons/guia02.svg" class="col-sm-12 col-md-2 me-5 iconoMenu" v-show="seleccionadoE"/>
        <img src="../../../../public/icons/guia01.svg" class="col-sm-12 col-md-2 me-5 iconoMenu" v-show="!seleccionadoE"/>
        <div id="enlaceE">
          <span class="col-md-10 textoNavegacion" :class="`${subrayadoE}`">Guía de</span><br>
          <span class="col-md-10 textoNavegacion" :class="`${subrayadoE}`">Referecia</span>
        </div>
      </a>
      <!-- <a class="btn text-start w-100 mt-4 texto" @click="seleccion('f')">
        <img src="../../../../public/icons/.svg" class="col-sm-12 col-md-2 me-5 iconoMenu" v-show="seleccionadoE"/>
        <img src="../../../../public/icons/.svg" class="col-sm-12 col-md-2 me-5 iconoMenu" v-show="!seleccionadoE"/>
        <span class="col-md-10 textoNavegacion" :class="`${subrayadoF}`">Usuarios</span>
      </a> -->
    </div>
  </nav>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "NavegacionLateral",

  props: {
    seleccionadoE: false,
    subrayadoE: '',
    seleccionA: false, 
    seleccionB: false,
    seleccionC: false,
    seleccionD: false,
    remarcadoA: '',
    remarcadoB: '',
    remarcadoC: '',
    remarcadoD: ''
  },

  data () {
    return {
      seleccionadoA: this.seleccionA,
      seleccionadoB: this.seleccionB,
      seleccionadoC: this.seleccionC,
      seleccionadoD: this.seleccionD,
      subrayadoA: this.remarcadoA,
      subrayadoB: this.remarcadoB,
      subrayadoC: this.remarcadoC,
      subrayadoD: this.remarcadoD,
    }
  },

  methods: {
    seleccion(valor) {
      let estatus = 0
      if(valor == 'a') {
        this.seleccionadoA = true
        this.seleccionadoB = false
        this.seleccionadoC = false
        this.seleccionadoD = false
        this.subrayadoA = 'text-decoration-underline'
        this.subrayadoB = ''
        this.subrayadoC = ''
        this.subrayadoD = ''
        this.$router.push({ name: 'ListaPrincipal', params: {estatus}})
      }
      if(valor == 'b') {
        this.seleccionadoA = false
        this.seleccionadoB = true
        this.seleccionadoC = false
        this.seleccionadoD = false
        this.subrayadoA = ''
        this.subrayadoB = 'text-decoration-underline'
        this.subrayadoC = ''
        this.subrayadoD = ''
        estatus = 1
        this.$router.push({ name: 'ListaPrincipal', params: {estatus}})
      }
      if(valor == 'c') {
        this.seleccionadoA = false
        this.seleccionadoB = false
        this.seleccionadoC = true
        this.seleccionadoD = false
        this.subrayadoA = ''
        this.subrayadoB = ''
        this.subrayadoC = 'text-decoration-underline'
        this.subrayadoD = ''
        estatus = 2
        this.$router.push({ name: 'ListaPrincipal', params: {estatus}})
      }
      if(valor == 'd') {
        this.seleccionadoA = false
        this.seleccionadoB = false
        this.seleccionadoC = false
        this.seleccionadoD = true
        this.subrayadoA = ''
        this.subrayadoB = ''
        this.subrayadoC = ''
        this.subrayadoD = 'text-decoration-underline'
        estatus = 3
        this.$router.push({ name: 'ListaPrincipal', params: {estatus}})
      }
      if(valor == 'e') {
        this.seleccionadoA = false
        this.seleccionadoB = false
        this.seleccionadoC = false
        this.seleccionadoD = false
        this.subrayadoA = ''
        this.subrayadoB = ''
        this.subrayadoC = ''
        this.subrayadoD = ''
        this.$router.push({ name: 'GuiaReferencia'})
      }
      if(valor == 'f') {
        this.seleccionadoA = false
        this.seleccionadoB = false
        this.seleccionadoC = false
        this.seleccionadoD = false
        this.subrayadoA = ''
        this.subrayadoB = ''
        this.subrayadoC = ''
        this.subrayadoD = ''
        this.$router.push({ name: 'RegistroUsuario'})
      }
    }
  }
})
</script>

<style scoped>
  @media (min-width: 992px) {
    .navbar-small {
      display: none;
    }

    .navbar-normal {
      display: block;
    }
  }

  @media (max-width: 992px) {
    .navbar-small {
      display: block;
    }

    .navbar-normal {
      display: none;
    }
  }

  h2 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 35px;
    line-height: 43px;
    margin-top: 70px;
    /*margin-left: 48px;*/
    margin-left: 10%;
    margin-right: 10%;
  }

  .texto {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #FFFFFF;
  }

  .iconoMenu, .iconoGuia {
    width: 50px;
  }

  #enlaceE {
    margin-top: -45px;
    margin-left: 55px;
  }

  .menuLateral {
    margin-left: 2.5%;
  }

  a:hover {
    color: white;
  }

  @media (max-width: 1280px) {
    .textoNavegacion {
      display: none;
    }
    .iconoMenu {
      width: 50px;
      margin-left: 35%;
    }
  }
  /*
  #navegacionLateral {
    width: 245px;
  }
  */
</style>
